/** Formatos padronizados da API (/api/v1). */
export interface ErroApi {
  code: string;
  message: string;
  details?: unknown;
}

export interface Pagina<T> {
  itens: T[];
  proximo_cursor: string | null;
}

export const LIMITE_PADRAO = 50;
export const LIMITE_MAXIMO = 200;
/**
 * Teto da `busca` das listas paginadas (`EntradaPaginada`). Review r27 robustez (O2): a Tabela confere a visão salva por ele
 * antes de aplicá-la (a visão com uma busca maior dava 422 na lista em toda abertura).
 */
export const TETO_BUSCA = 200;
